function customerExternalId(customer) {
  const raw = customer?.customerIdExt ?? customer?.CustomerIdExt;
  if (raw == null) return null;
  const text = String(raw).trim();
  if (!/^\d+$/.test(text)) return null;
  const id = Number(text);
  if (!Number.isSafeInteger(id) || id <= 0) return null;
  return id;
}

function partyFromVendor(vendor) {
  const id = Number(vendor?.id);
  const name = String(vendor?.vendorName ?? vendor?.VendorName ?? '').trim();
  if (!Number.isSafeInteger(id) || id <= 0 || !name) return null;
  return {
    id,
    vendorName: name,
    vendorNo: String(vendor?.vendorNo ?? vendor?.VendorNo ?? '').trim(),
    partyType: 'Vendor',
  };
}

function partyFromCustomer(customer) {
  const id = customerExternalId(customer);
  const name = String(customer?.customerName ?? customer?.CustomerName ?? '').trim();
  const status = String(customer?.status ?? customer?.Status ?? '').trim().toLowerCase();
  if (id == null || !name || status !== 'active') return null;
  return {
    id,
    vendorName: name,
    vendorNo: String(customer?.customerNumber ?? customer?.CustomerNumber ?? '').trim(),
    partyType: 'Customer',
  };
}

export function mergeVendorAndCustomerParties(vendors, customers) {
  const parties = [];
  const seen = new Set();
  (vendors || []).forEach(vendor => {
    const party = partyFromVendor(vendor);
    if (!party || seen.has(party.id)) return;
    seen.add(party.id);
    parties.push(party);
  });
  (customers || []).forEach(customer => {
    const party = partyFromCustomer(customer);
    if (!party || seen.has(party.id)) return;
    seen.add(party.id);
    parties.push(party);
  });
  parties.sort((a, b) => a.vendorName.localeCompare(b.vendorName, undefined, { sensitivity: 'base' }));
  return parties;
}

export function partySelectGroups(parties) {
  const toOption = party => ({
    value: party.id,
    label: party.vendorName,
    vendorNo: party.vendorNo,
    partyType: party.partyType,
  });
  const vendorOptions = (parties || []).filter(party => party.partyType === 'Vendor').map(toOption);
  const customerOptions = (parties || []).filter(party => party.partyType === 'Customer').map(toOption);
  return [
    vendorOptions.length ? { label: 'Vendors', options: vendorOptions } : null,
    customerOptions.length ? { label: 'Customers', options: customerOptions } : null,
  ].filter(Boolean);
}

export function flattenPartyOptions(groups) {
  return (groups || []).flatMap(group => group.options || []);
}

export function findPartyName(parties, id) {
  const match = (parties || []).find(party => String(party.id) === String(id));
  return match?.vendorName || '';
}
